var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.63623,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#05E785"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2980_6793)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2980_6793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6051 15.1023C21.765 13.7341 19.854 11.4385 16.5 11.4385C13.146 11.4385 11.235 13.7341 10.3948 15.1023C10.1351 15.5224 9.99756 16.0065 9.99756 16.5004C9.99756 16.9942 10.1351 17.4783 10.3948 17.8984C11.235 19.2666 13.146 21.5622 16.5 21.5622C19.854 21.5622 21.765 19.2666 22.6051 17.8984C22.8648 17.4783 23.0024 16.9942 23.0024 16.5004C23.0024 16.0065 22.8648 15.5224 22.6051 15.1023ZM21.6816 17.3313C20.9601 18.5045 19.3269 20.4789 16.5 20.4789C13.673 20.4789 12.0399 18.5045 11.3184 17.3313C11.1641 17.0816 11.0824 16.7939 11.0824 16.5004C11.0824 16.2068 11.1641 15.9191 11.3184 15.6694C12.0399 14.4962 13.673 12.5218 16.5 12.5218C19.3269 12.5218 20.9601 14.494 21.6816 15.6694C21.8359 15.9191 21.9176 16.2068 21.9176 16.5004C21.9176 16.7939 21.8359 17.0816 21.6816 17.3313Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 13.792C15.9642 13.792 15.4406 13.9508 14.9952 14.2484C14.5498 14.546 14.2027 14.969 13.9977 15.4639C13.7927 15.9588 13.739 16.5033 13.8435 17.0287C13.948 17.5541 14.206 18.0366 14.5848 18.4154C14.9635 18.7942 15.4461 19.0521 15.9715 19.1566C16.4968 19.2611 17.0414 19.2075 17.5363 19.0025C18.0312 18.7975 18.4541 18.4504 18.7517 18.005C19.0493 17.5596 19.2082 17.036 19.2082 16.5003C19.2073 15.7823 18.9217 15.0939 18.414 14.5862C17.9062 14.0785 17.2179 13.7929 16.4998 13.792ZM16.4998 18.1253C16.1784 18.1253 15.8643 18.03 15.597 17.8515C15.3298 17.6729 15.1215 17.4191 14.9985 17.1222C14.8755 16.8253 14.8434 16.4985 14.9061 16.1833C14.9688 15.8681 15.1235 15.5785 15.3508 15.3513C15.578 15.124 15.8676 14.9693 16.1828 14.9065C16.498 14.8438 16.8248 14.876 17.1217 14.999C17.4186 15.122 17.6724 15.3303 17.851 15.5975C18.0295 15.8648 18.1248 16.1789 18.1248 16.5003C18.1248 16.9313 17.9536 17.3446 17.6489 17.6494C17.3441 17.9541 16.9308 18.1253 16.4998 18.1253Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2980_6793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2980_6793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf1);
export default __webpack_public_path__ + "static/media/pdf 1.c3e464257b86fd7ab6a4b7486c71eadb.svg";
export { ForwardRef as ReactComponent };